import { h, Component } from 'preact';

import TimeMissingCard from '../TimeMissingCard';
import railsDateToChronometer from '../../utils/railsDateToChronometer';

class ItemOffer extends Component {
  componentDidMount() {
    if (this.props.hasSealsCarousel) {
      this.initSealsCarousel();
    }
  }

  initSealsCarousel() {
    const carousel = this.base.querySelector('.seal__carousel');
    if (!carousel) return;

    const track = carousel.querySelector('.seal__track');
    const items = carousel.querySelectorAll('.seal__item');
    const leftBtn = carousel.querySelector('.seal__arrow-left');
    const rightBtn = carousel.querySelector('.seal__arrow-right');

    if (!track || items.length === 0 || !leftBtn || !rightBtn) return;

    let index = 0;

    const update = () => {
      const itemWidth = items[0].offsetWidth;
      track.style.transform = `translateX(-${index * itemWidth}px)`;

      leftBtn.disabled = index === 0;
      rightBtn.disabled = index >= items.length - 1;
    };

    leftBtn.addEventListener('click', () => {
      if (index > 0) {
        index--;
        update();
      }
    });

    rightBtn.addEventListener('click', () => {
      if (index < items.length - 1) {
        index++;
        update();
      }
    });

    update();
  }

  render() {
    const {
      image,
      title,
      subtitle,
      seal_list,
      expired_at,
      part_link,
      slug,
      secondary_call,
      main_call,
      featured,
      description,
      extra,
      badge,
      hasSealsCarousel,
    } = this.props;

    return (
      <div className="card">
        <div className="list-offers__container-time">
          <TimeMissingCard date={railsDateToChronometer(expired_at)} />
        </div>

        <div className="card__header">
          <a className="list-offers__card-link" href={`${part_link}/${slug}`}>
            <div className="card__image">
              <div
                className="card__image-value"
                style={`background-image: url(${image})`}
              ></div>
            </div>
          </a>
        </div>

        <div className="card__content">
          <div data-match-height="offer-vehicle-card-content">
            <div className="card__title" title={title}>
              {title}
            </div>
            <div className="card__subtitle">{subtitle}</div>
          </div>
          <hr className="card__separator" />
          {hasSealsCarousel ? (
            <div
              className="seal__carousel"
              data-index="0"
              data-match-height="parts-card-seal-carousel"
            >
              {seal_list.length > 0 && (
                <button class="seal__arrow-left left" aria-label="prev">
                  <i className="icon icon-arrow-right"></i>
                </button>
              )}

              <ul className="seal__track">
                {seal_list.map((seal, index) => (
                  <li key={index} className="seal__item">
                    {seal}
                  </li>
                ))}
              </ul>

              {seal_list.length > 0 && (
                <button className="seal__arrow-right right" aria-label="next">
                  <i className="icon icon-arrow-right"></i>
                </button>
              )}
            </div>
          ) : (
            <div data-match-height="offer-vehicle-card-list">
              {seal_list && seal_list.length > 0 && (
                <div>
                  <ul className="card__list list">
                    {seal_list.slice(0, 3).map(text => (
                      <li>{text}</li>
                    ))}
                  </ul>
                  <hr className="card__separator" />
                </div>
              )}
            </div>
          )}
        </div>

        <div data-match-height="card-footer" className="card__footer">
          <div
            data-match-height="offer-vehicle-footer"
            className="card__box-offer"
          >
            {secondary_call && (
              <div className="card__trigger">{secondary_call}</div>
            )}
            {main_call && <div className="card__title">{main_call}</div>}
            {featured && <div className="card__trigger-value">{featured}</div>}
            {description && (
              <div className="card__trigger-description">{description}</div>
            )}
            {extra && <div className="card__trigger-description">{extra}</div>}
            {badge && (
              <div className="badge badge-primary badge--pill">{badge}</div>
            )}
          </div>
          <a
            href={`${part_link}/${slug}`}
            className="list-offers__card-link btn button button--primary button--block button--large card__cta"
          >
            ESTOU INTERESSADO
          </a>
        </div>
      </div>
    );
  }
}

ItemOffer.defaultProps = {
  list: [],
  seal_list: [],
  image: 'http://via.placeholder.com/210x110',
  hasSealsCarousel: false,
};

export default ItemOffer;
